import { L } from '@lib';
import { RequestPriority } from '@models';
import { Tag, Typography } from 'antd';
import React from 'react';

const { Text } = Typography;

interface IProps {
  priority: string;
}

export const RequestPriorityTag: React.FC<IProps> = ({ priority }) => {
  return (
    <>
      {priority === RequestPriority.High && (
        <Tag color="#FFF1F0" style={{ border: '1px solid #F5222D' }}>
          <Text style={{ color: '#F5222D' }}>{L('High')}</Text>
        </Tag>
      )}
      {priority === RequestPriority.Medium && (
        <Tag color="#E6F7FF" style={{ border: '1px solid #1890FF' }}>
          <Text style={{ color: '#1890FF' }}>{L('Medium')}</Text>
        </Tag>
      )}
      {priority === RequestPriority.Low && (
        <Tag color="#F2F6CE" style={{ border: '1px solid #638A00' }}>
          <Text style={{ color: '#638A00' }}>{L('Low')}</Text>
        </Tag>
      )}
    </>
  );
};
